import { render } from "./TiredEyes.vue?vue&type=template&id=12d030dc&scoped=true"
import script from "./TiredEyes.vue?vue&type=script&lang=js"
export * from "./TiredEyes.vue?vue&type=script&lang=js"

import "./TiredEyes.vue?vue&type=style&index=0&id=12d030dc&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d030dc"]])

export default __exports__